import { StoreRootState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Outlet, useNavigate } from 'react-router-dom';

const IsAlreadyAuth = ({ redirectTo = '/'}: { redirectTo: string; }) => {
	const navigate = useNavigate();
	const { user } = useSelector((state: StoreRootState) => state.auth);
	useEffect(() => {
		if (user) navigate(redirectTo);
	}, [user]);
	return <Outlet />;
};

export default IsAlreadyAuth;
